import React from 'react';

import {WrapperDiv, TextStyles, ImgStyles} from './UserAvatar.styles';

const UserAvatar = ({userImg = '', firstName = '', lastName = ''}) => {
  return (
    <WrapperDiv>
      {userImg ? (
        <ImgStyles src={userImg} />
      ) : (
        <TextStyles>
          {firstName && firstName.charAt(0)}
          {lastName && lastName.charAt(0)}
        </TextStyles>
      )}
    </WrapperDiv>
  );
};

export default UserAvatar;
